import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import {
  ApiResponseModel,
  ApiVisa,
  BaseApiTemplateService,
  BasicApiResponseModel,
  Core2Config,
} from "../../../shared";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class JobShipmentAddHubService extends BaseApiTemplateService<any> {
  constructor(http: HttpClient) {
    super();
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX + "del/job-shipments/add-logistic-hub/backoffice-ep";
    this.httpClient = http;
  }

  addHubToJobShipments(
    dto: any,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }

    return this.httpClient.post<BasicApiResponseModel<any>>(
      this.apiUrl,
      dto,
      this.getHttpHeader(visa)
    );
  }

  bulkEditArrivalAndDepartureDates(dto: any,visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    let apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + "del/job-shipments/bulk-edit-arrival-and-departure/backoffice-ep";
    return this.httpClient.post<BasicApiResponseModel<any>>(
      apiUrl,
      dto,
      this.getHttpHeader(visa)
    );
  }
}
